module.exports = __webpack_public_path__ + "img/digital_3.3f807dc0.png";